import { MAP_TYPES } from '@deck.gl/carto';
 
const WAZEALERTS_SOURCE_ID = 'wazeAlertsSource';
 
const source = {
  id: WAZEALERTS_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: `SELECT geom, Street, City, Timestamp, Incident_Type, Incident_Subtype, Location_Category FROM (SELECT geom, Street, City, FORMAT_TIMESTAMP('%Y-%m-%d %l:%M:%S %p', Timestamp) AS Timestamp, Incident_Type, Incident_Subtype, Location_Category FROM us-con-gcp-npr-0000424-011325.diamond.Waze_Alerts WHERE Timestamp >= TIMESTAMP_SUB(TIMESTAMP(CURRENT_DATETIME('America/New_York')), INTERVAL 6 HOUR)) -- nocache:${Date.now()}`,
};
 
export default source;